import React from 'react';
import AppModal from '../../common/AppModal';
import ChainMaintenancePanel from './ChainMaintenancePanel';

interface CFFDRSAdminModalProps {
  station: any;
  isOpen: boolean;
  onClose: () => void;
}

export const CFFDRSAdminModal: React.FC<CFFDRSAdminModalProps> = ({ station, isOpen, onClose }) => {
  return (
    <AppModal isOpen={isOpen} onClose={onClose} width={540}>
      <div style={{ padding: '0 4px' }}>
        <h2 style={{
          margin: '0 0 16px 0',
          fontSize: 'var(--em3-font-size-xl)',
          fontWeight: 'var(--em3-font-weight-semibold)',
          color: 'var(--em3-color-text-primary)',
          borderBottom: '1px solid var(--em3-color-border)',
          paddingBottom: '12px',
        }}>
          CFFDRS Admin — {station?.name}
        </h2>
        <ChainMaintenancePanel station={station} />
      </div>
    </AppModal>
  );
};

export default CFFDRSAdminModal;
